document.addEventListener('DOMContentLoaded', function () {
    function openTooltip() {
        const tooltip = document.querySelector('.ribbon-with-tooltip__tooltip--info');
        tooltip.classList.add('js-opened');

        const tooltipText = document.querySelector('.ribbon-with-tooltip__tooltip--info > p');
        tooltipText.classList.add('js-opened');

        window.removeEventListener('scroll', scrollHandler);
    }

    function closeTooltip() {
        const tooltip = document.querySelector('.ribbon-with-tooltip__tooltip--info');
        tooltip.classList.remove('js-opened');

        const tooltipText = document.querySelector('.ribbon-with-tooltip__tooltip--info > p');
        tooltipText.classList.remove('js-opened');
    }

    function scrollHandler() {
        if (window.scrollY > 200) {
            openTooltip();
        }
    }

    window.addEventListener('scroll', scrollHandler);

    document.addEventListener('click', function(event) {
        const tooltip = document.querySelector('.ribbon-with-tooltip__tooltip--info');
        if (!tooltip.contains(event.target)) {
            closeTooltip();
        }
    });
});